var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconKo = function SvgIconKo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 54",
    d: "M10 1.818A8.182 8.182 0 111.818 10 8.182 8.182 0 0110 1.818M10 0a9.954 9.954 0 107.084 2.915A10 10 0 0010 0z",
    fill: "#712C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 55",
    d: "M11.28 10.003l2.563-2.517a.961.961 0 00.092-1.236.87.87 0 00-1.373-.092L10 8.719 7.437 6.156a.87.87 0 00-1.373.092.961.961 0 00.092 1.236l2.562 2.519-2.563 2.517a.961.961 0 00-.092 1.236.87.87 0 001.373.092l2.563-2.563 2.563 2.563a.87.87 0 001.373-.092.961.961 0 00-.092-1.236z",
    fill: "#712C2C"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconKo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iconKO.8ebc2d4a11bc8416bf783bec403b6da5.svg";